



























import Vue from 'vue';

import { Component, InjectReactive, Prop } from 'vue-property-decorator';

import AllCourseSearchCards from 'frontend/components/search/AllCourseSearchCards.vue';
import AllCourseSearchCardsMobile from 'frontend/components/search/AllCourseSearchCardsMobile.vue';
import { CourseData, CourseHit } from 'frontend/components/search/types';

@Component({
  components: {
    AllCourseSearchCards,
    AllCourseSearchCardsMobile,
  },
})
export default class AlgoliaCourseHits extends Vue {
  @InjectReactive() readonly coursesHits!: CourseHit[];
  @InjectReactive() readonly searchQuery!: string;
  @InjectReactive() readonly courseQueryID!: string;
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
  @Prop(Boolean) private isStaffUser!: boolean;

  private get courses(): CourseData[] {
    return this.coursesHits.map(course => ({
      url: course.course_url,
      image_url: course.course_image_url,
      name: course.course_name,
      id: course.course_id,
      object_id: course.objectID,
      is_published: course.course_is_published,
    }));
  }
}
